import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useControlPanelSection() {
  const location = useLocation();
  const navigate = useNavigate();

  // Get current section from query params, default to 'reassign-application'
  const getCurrentSection = useCallback(() => {
    const params = new URLSearchParams(location.search);
    return params.get('section') || 'reassign-application';
  }, [location.search]);

  // Set active section via query params
  const setSection = useCallback(
    (section: string) => {
      const params = new URLSearchParams(location.search);
      params.set('section', section);
      navigate(`/workbench/controlpanel?${params.toString()}`, {
        replace: true,
      });
    },
    [location.search, navigate],
  );

  return {
    currentSection: getCurrentSection(),
    setSection,
  };
}
